export const environment = {
    production: false,
    // apiUrl: 'https://api.econsent.com.br',
    // default: 'https://api.econsent.com.br',
    apiUrl: 'https://api-staging.econsent.com.br',
    default: 'https://api-staging.econsent.com.br',
    apiEndpoint: '',
    brySigningTimeout: 300000, // 5 minutes
    signatureStatusPollInterval: 10000, // 10 seconds
    hmr: true,
};

environment.apiEndpoint = `${environment.apiUrl}/api`;
